import React from "react"

import type { StackProps } from "@chakra-ui/react"
import { Flex, forwardRef, Stack, Text } from "@chakra-ui/react"

import { InfoTooltip } from "@supliful/common"

type Props = { label?: string; tooltip?: string } & StackProps

export const Labeled = forwardRef(
  ({ label, tooltip, children, ...rest }: Props, ref) => {
    return (
      <Stack spacing={1} ref={ref} {...rest}>
        {label && (
          <Stack direction="row" align="center" spacing={1}>
            <Text fontSize={12} color="tertiary.900">
              {label}
            </Text>

            {tooltip && (
              <InfoTooltip
                label={tooltip}
                iconProps={{ color: "tertiary.900" }}
              />
            )}
          </Stack>
        )}

        <Flex minH={8} alignItems="center">
          {children}
        </Flex>
      </Stack>
    )
  },
)
